import { inject, provideAppInitializer } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AuthStateProvider } from '../services/auth/auth-state.provider';
import { catchNotification, loadWebConfig } from '../services/web-config/web-config.helper';
import { WebConfigService } from '../services/web-config/web-config.service';

export const WebConfigProvider = provideAppInitializer(() => {
  const authStateProvider = inject(AuthStateProvider);
  const webConfigService = inject(WebConfigService);
  return loadWebConfig()
    .then(() => webConfigService.overWriteConfig())
    .then(() => lastValueFrom(authStateProvider.fetchDetails()))
    .then(() => webConfigService.getConfigOnInterval())
    .catch(catchNotification);
});
